import { FONT } from "@/styles/common";
import { Box, Container, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomContainer = styled(Container)`
    & .carousel .control-dots {
        width: auto;
        right: 8%;
        top: 50%;
        transform: translateY(-50%);
        bottom: auto;

        & .dot {
            width: 16px;
            height: 16px;
            margin-bottom: 16px;
            display: block;
            box-shadow: none;
        }

        & .dot:last-of-type {
            margin-bottom: 0 !important;
        }
    }
`;

export const CustomBox = styled(Box)`
    position: relative;
    padding-left: 168px;

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        padding-left: 0;
    }

    &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 120px;
        height: 1px;
        background: ${({ theme }) => theme.COLOR.white};

        @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
            display: none;
        }
    }
`;

export const CustomTitle = styled(Text)`
    color: ${({ theme }) => theme.COLOR.white};
    ${FONT("cormorant", 60, 700, 1.2)}

    @media (max-width:${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("cormorant", 32, 700, 1.2)}
    }
`;

export const CustomText = styled(Text)`
    color: ${({ theme }) => theme.COLOR.white};
    ${FONT("pretendard", 14, 500, 1.5)}
`;
